<script>
import { required, numeric } from "vuelidate/lib/validators";
import validationMessages from "@/components/validations";
import Merchandising from "@/services/Merchandising";
import Swal from "sweetalert2";

export default {
  props:['id','attr_id','name','description','order'],
  components: { validationMessages },

  data() {
    return {
      showModal: false,
      submitted: false,
      tryingToSubmit: false,
      showLoader: false,
      csrf_token: localStorage.getItem("csrf_token"),
      termID:'',
      attrID:'',
      termName:'',
      termOrder:'',
      termDescription:'',

    };
  },

  validations: {
    termName: { required },

  },

  methods: {


    async submitForm() {
      this.tryingToSubmit = true;

      if (this.$v.$invalid) {
        this.submitted = true;
        this.tryingToSubmit = false;
        return;
      }

      this.showLoader = true;
      let formData = new FormData();
      formData.append("term_id", this.termID);
      formData.append("attr_id", this.attrID);
      formData.append("name", this.termName);
      formData.append("description", this.termDescription);
      formData.append("order", this.termOrder);
      formData.append('_method', 'PATCH')

      try {
        const response = await Merchandising.updateTerm(formData);
        if (response.success === false) {
          Swal.fire("Error", response.error || "Failed to update term. Please try again.", "error");
        } else {
          Swal.fire("Success", "Term successfully updated!", "success");
          this.closeModal();
          this.refreshData();
        }

      } catch (error) {
        // Catch any network or unexpected errors
        console.error("Failed to create term:", error);
        Swal.fire("Error", error.response?.data?.error || "Failed to create term. Please try again.", "error");
      } finally {
        this.tryingToSubmit = false;
        this.showLoader = false;
      }
    },


    resetForm() {
      this.$v.$reset();
      this.termName = '';
      this.termID = '';
      this.attrID = '';
      this.termOrder = '';
      this.termDescription = '';

    },

    closeModal() {
      this.resetForm();
      this.showModal = false;
    },



    refreshData() {
      this.$emit("onRefresh");
    },
    syncData(){
     this.termID = this.id;
     this.termName = this.name;
     this.termOrder = this.order;
     this.attrID = this.attr_id;
     this.termDescription = this.description;
      console.log(this.termDescription,'description')
      console.log(this.description,'description from parent')
    }
  },
};
</script>

<template>
  <b-modal
      @hidden="resetForm"
      @shown="syncData"
      id="update_term"
      size="l"
      v-model="showModal"
      title="Edit Term"
      title-class="font-18"
  >
    <form @submit.prevent="submitForm">
      <div class="row">
        <div v-if="showLoader" class="card-body d-flex align-items-center justify-content-center">
          <b-spinner large></b-spinner>
        </div>
        <div v-else>
          <b-card-text>
            <b-form-group label="Term Name" class="mb-3">
              <b-form-input
                  v-model.trim="termName"
                  :class="{ 'is-invalid': submitted && $v.termName.$error }"
              ></b-form-input>
              <validationMessages
                  v-if="submitted"
                  :fieldName="'Term Name'"
                  :validationName="$v.termName"
              ></validationMessages>
            </b-form-group>

            <b-form-group label="Term Description" class="mb-3">
              <b-form-input
                  v-model.trim="termDescription"
              ></b-form-input>
            </b-form-group>



            <b-form-group label="Term Order" class="mb-3">
              <b-form-input
                  v-model.trim="termOrder"
              ></b-form-input>

            </b-form-group>
          </b-card-text>
        </div>
      </div>
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="submitForm" :disabled="tryingToSubmit || showLoader">
        <b-spinner v-show="tryingToSubmit" small></b-spinner>Submit
      </b-button>
    </template>
  </b-modal>
</template>
